




















import { Component, Mixins, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import TreeSelect from '@/components/tree-select/index.vue'
import CategoryApi from '@/api/goods/customCategory'
import PicModal from '@/components/upload/picModal.vue'
import CustomCategoryProduct from '../product/index.vue'

const defaultParentId = '-1'

@Component({
  components: {
    CustomForm,
    TreeSelect,
    PicModal,
    CustomCategoryProduct,
  },
})
export default class CustomCategoryEdit extends AbpBase {
  parentId: any = JSON.stringify({ value: defaultParentId })
  categorys: any[] = [
    {
      value: defaultParentId,
      label: '顶级分类',
      children: [],
    },
  ]
  filters = [
    {
      label: '分类名称：',
      type: 'input',
      rule: { required: true, message: '请输入分类名称', trigger: 'blur' },
      key: 'name',
    },
    {
      label: '外部分类：',
      type: 'input',
      isShow: this.isVicutuProject,
      rule: { required: false, message: '请输入外部分类：', trigger: 'blur' },
      key: 'externId',
    },
    {
      label: '排序：',
      type: 'input-number',
      key: 'displayOrder',
      props: {
        min: 0,
      },
    },
    // {
    //   label: '是否显示：',
    //   type: 'switch',
    //   key: 'published',
    //   defaultValue: true
    // }
  ]
  submitText: string = '保存并继续编辑'
  editId: any = null
  pictureUrl = ''
  level = 0 // 当前分类的等级
  childrenLevel = 0
  mounted() {
    if (this.$route.params['id']) {
      this.editId = this.$route.params['id']
      this.submitText = '保存并返回分组'
      this.getData()
    }
    this.getCategoryTree()
  }

  /**
   * 选择图片
   */
  picChange(event) {
    this.pictureUrl = event[0].url
  }

  onSubmit(form, valid) {
    if (valid) {
      let { parentId, editId } = this
      let parent = JSON.parse(parentId)
      let isvalid = this.selectChange(parentId)
      if (isvalid) {
        return
      }

      // if (!this.pictureUrl) {
      // 	this.$Modal.error({
      // 		title: "请选择分类图"
      // 	});
      // 	return;
      // }
      let obj: any = {
        parentId: parent.value === defaultParentId ? null : parent.value,
        pictureUrl: this.pictureUrl,
      }
      let { displayOrder, name, published, externId } = form
      Object.assign(obj, { displayOrder, name, published, externId })
      CategoryApi.edit(editId, obj).then((res) => {
        this.$Message.success(editId ? '修改成功' : '添加成功')
        // this.$router.push({ name: 'customCategory', replace: true })
        if (this.editId) {
          this.$router.push({
            name: 'customCategory',
          })
        } else {
          this.$router.push({
            name: 'customCategoryEdit',
            params: { id: res.data.id },
          })
        }
      })
    }
  }

  getData() {
    if (!this.editId) {
      return
    }
    CategoryApi.getDataById(this.editId).then((res) => {
      let {
        displayOrder,
        parentId,
        name,
        pictureUrl,
        published,
        parent,
        level,
        externId,
      } = res.data
      if (parent) {
        this.parentId = JSON.stringify({
          value: parent.id,
          level: parent.level,
          code: parent.code,
        })
      }
      this.level = level
      this.pictureUrl = pictureUrl
        ; (this.$refs.formEdit as any).setForm({
          displayOrder,
          name,
          published,
          externId,
        })
    })
  }

  /**
   * 判断分类子分类有几级
   */
  childrenLevelFn(list) {
    let vm = this
    if (!vm.editId) {
      return
    }
    list.forEach((item) => {
      if (item.value == vm.editId) {
        vm.getMaxFloor(item.children)
      } else if (item.children.length > 0) {
        vm.childrenLevelFn(item.children)
      }
    })
  }

  getMaxFloor(treeData) {
    let vm = this
    vm.childrenLevel = 0
    function each(data, floor) {
      data.forEach((e) => {
        if (floor > vm.childrenLevel) {
          vm.childrenLevel = floor
        }
        if (e.children.length > 0) {
          each(e.children, floor + 1)
        }
      })
    }
    each(treeData, 1)
  }

  /**
   * 上级分类选择验证
   */
  selectChange(event) {
    let parent = JSON.parse(event)
    let { level, childrenLevel, editId } = this
    if (parent.value == editId) {
      this.$Modal.error({
        title: '上级分类不能是当前分类',
      })
      return true
    }
    if (editId) {
      let id = editId.replace(/-/g, '')
      if (parent.code && parent.code.indexOf(id) > -1) {
        this.$Modal.error({
          title: '不能移动到此分类,请更换上级分类',
        })
        return true
      } else if (parent.level + childrenLevel + 1 > 3) {
        this.$Modal.error({
          title: '分类不能超过3级,请更换上级分类',
        })
        return true
      }
    } else if (parent.level >= 3) {
      this.$Modal.error({
        title: '分类不能超过3级,请更换上级分类',
      })
      return true
    }
  }

  getCategoryTree() {
    CategoryApi.getTreeData().then((res) => {
      this.categorys = [
        {
          value: defaultParentId,
          label: '顶级分类',
          children: res.data,
        },
      ]
      this.childrenLevelFn(this.categorys)
    })
  }
}
